import {
  Component,
  Input,
  HostListener,
  OnInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomerServiceDialogComponent } from '../../page/customer-service-dialog/customer-service-dialog.component';
import { BusPassengerDialogComponent } from '../bus-passenger-dialog/bus-passenger-dialog.component';
import { OrderConfirmDialogComponent } from '../../order-confirm-dialog/order-confirm-dialog.component';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { FleetPackageModalComponent } from '../fleet-package-modal/fleet-package-modal.component';
import { Router } from '@angular/router';
import { ChooseCompensateNetflixModalComponent } from '../../compensate/choose-compensate-netflix-modal/choose-compensate-netflix-modal.component';
import { ChooseCompensateYoutubeModalComponent } from '../../compensate/choose-compensate-youtube-modal/choose-compensate-youtube-modal.component';
import { GeminiTipModalComponent } from '../gemini-tip-modal/gemini-tip-modal.component';
import { ChangeAccountErrorModalComponent } from '../change-account-error-modal/change-account-error-modal.component';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { ChooseCompensateAdobeModalComponent } from '../../compensate/choose-compensate-adobe-modal/choose-compensate-adobe-modal.component';

@Component({
  selector: 'app-bus-seat-ticket',
  templateUrl: './bus-seat-ticket.component.html',
  styleUrls: ['./bus-seat-ticket.component.scss'],
})
export class BusSeatTicketComponent implements OnInit, OnChanges {
  @Input() status: any;
  @Input() username: any;
  @Input() bus_id: any;
  @Input() isExpanded = false;

  constructor(
    private dialog: MatDialog,
    private api: ProductApiService,
    private busApi: BusApiService,
    private router: Router,
    private userApi: UserApiService,
  ) {}

  ngOnInit(): void {
    // this.findBusSeats();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['username'] || changes['bus_id'] || changes['status']) {
      if (changes['username']) {
        this.bus_id = '';
      }
      if (changes['bus_id']) {
        this.username = '';
      }
      if (changes['status']) {
        this.bus_id = '';
        this.username = '';
      }
      this.page = 0;
      this.seats = [];
      this.hasMore = true;
      this.findBusSeats();
    }
  }

  openService() {
    this.dialog.open(CustomerServiceDialogComponent, {
      autoFocus: false,
      panelClass: 'app-dialog',
    });
  }

  openPassager(data: any) {
    this.dialog.open(BusPassengerDialogComponent, {
      autoFocus: false,
      panelClass: 'app-dialog',
      data: data.bus,
    });
  }

  openAiCustomerService() {
    this.getDingdingData();
  }

  loading = false;
  busSeatID = 0;
  async renew(data: any) {
    try {
      this.loading = true;
      const r = await this.api.getBusType(data.bus.bus_type_id);
      if (data.status != 'Expired') {
        this.busSeatID = data.id;
      }
      this.dialog.open(OrderConfirmDialogComponent, {
        autoFocus: false,
        panelClass: 'app-dialog',
        data: {
          platform: r.data.platform,
          bus_type: r.data,
          exclusive: data.bus.exclusive,
          bus_seat_id: this.busSeatID,
        },
      });
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  use() {
    window.open('https://universalbus.cn/chatgpt-course');
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = window.innerHeight + window.scrollY;
    const max = document.scrollingElement?.scrollHeight || 0;

    if (offset > max - 500 && !this.loading && this.hasMore) {
      this.findBusSeats();
    }
  }

  seats: any = [];
  page = 0;
  pageSize = 50;
  hasMore = true;

  async findBusSeats() {
    try {
      this.page += 1;
      this.loading = true;
      const r = await this.busApi.findBusSeats(
        this.status,
        this.username,
        this.bus_id,
        this.page,
        this.pageSize,
      );
      const data = r.data || [];
      if (data.length < this.pageSize) {
        this.hasMore = false;
      }
      this.seats = this.seats.concat(data);
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  openFleetPackage() {
    this.dialog.open(FleetPackageModalComponent, {
      width: '910px',
    });
  }

  goto(name: string) {
    if (name === '爆米花') window.open('https://www.popcorn.plus/download');
    else if (name === '借个号') window.open('https://jiegehao.cn');
  }

  openCompensateNetflix(data: any) {
    this.dialog.open(ChooseCompensateNetflixModalComponent, {
      width: '590px',
      data: data,
      panelClass: 'overflow-dialog',
    });
  }

  openCompensateAdobe(data: any) {
    this.dialog.open(ChooseCompensateAdobeModalComponent, {
      width: '590px',
      data: data,
      panelClass: 'overflow-dialog',
    });
  }

  openCompensateYoutube(data: any) {
    this.dialog.open(ChooseCompensateYoutubeModalComponent, {
      width: '590px',
      data: data,
      panelClass: 'overflow-dialog',
    });
  }

  openGeminiTip() {
    this.dialog.open(GeminiTipModalComponent);
  }

  changeAccountError(data: any) {
    this.dialog.open(ChangeAccountErrorModalComponent, {
      data: data,
      width: '540px',
      panelClass: 'overflow-dialog',
    });
  }

  async getDingdingData() {
    try {
      const r = await this.userApi.getDingdingData();
      const dingding_url = r.data.access_url;
      window.open(dingding_url);
    } catch (error) {}
  }

  openWorkorder(data: any) {
    this.router.navigate(['/user/profile/form/create'], {
      queryParams: { id: data.id },
    });
  }
}
